// extracted by mini-css-extract-plugin
export default {"Checkbox":"LabelRadio_Checkbox__H7xW5"};